const openToBelong = document.querySelector('body.open-to-belong');

var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

window.onload = function() {

  if(openToBelong) {

    var ytIDD = document.getElementsByClassName('field--name-field-vid-youtube')[0].outerText;
    var ytIDM = document.getElementsByClassName('field--name-field-vid-youtube-mb')[0].outerText;
    const gifLoadVideo = document.getElementById('gif-loader')
    let pathOrigin = window.location.origin;
    const mediaScreen = window.screen.width < 768
  
    var player;
  
    function onYouTubeIframeAPIReady() {
      player = new YT.Player('player', {
        videoId: mediaScreen ? ytIDM : ytIDD,
        playerVars: {
          'autoplay': 1,
          'mute': 1,
          'controls': 0,
          'showinfo': 0,
          'rel': 0  
        },
        events: {
          'onReady': onPlayerReady,
        }
      });

      function onPlayerReady(event) {
        event.target.playVideo();
  
        const interval = setInterval(() => {
          
          let duration = parseInt(player.getDuration()) - 1
          let current = parseInt(player.getCurrentTime())

          if ( current == duration) {
            clearInterval(interval);
            window.location.href = `${pathOrigin}/user/register`
          }

          if (current > 0) {
            gifLoadVideo.remove()
          }

        }, 1000);
      
      }
    }
  
    onYouTubeIframeAPIReady()
  
  }

}



// WEBPACK FOOTER //
// ./js/components/otp/_otp--intro--video.js